// Module
var code = `<customer-breadcrumbs></customer-breadcrumbs>
<customer-profile-header></customer-profile-header>
<section class="box">
    <div class="info info--deposit">
      <div class="info-detail">
        <span class="key">Account number</span>
        <span class="value">{{\$ctrl.account.productNumber}}
        </span>
      </div>
    </div>

    <h2 class="section-header">Update account ATA</h2>

    <form name="\$ctrl.form">
      <table class="misc-transaction__table table table--generate-row-ids">
        <thead>
        <th></th>
        <th>Property</th>
        <th>Current state</th>
        <th>Target state</th>
        </thead>
        <tbody>

        <tr>
          <td></td>
          <td>Enabled</td>
          <td>{{\$ctrl.ata.enabled | prettyBoolean}}</td>
          <td>
            <select
              ng-model="\$ctrl.command.enabled"
              boolean-options>
            </select>
          </td>
        </tr>
        <tr ng-if="\$ctrl.command.enabled">
          <td></td>
          <td>Max no of linked accounts</td>
          <td>{{\$ctrl.ata.maxRelations}}</td>
          <td>
            <input
              ng-disabled="!\$ctrl.command.enabled"
              type="number"
              min="0"
              step="1"
              ng-model="\$ctrl.command.maxRelations">
          </td>
        </tr>
        <tr ng-if="\$ctrl.command.enabled">
          <td></td>
          <td>Allow linking accounts of related CIFs</td>
          <td>{{\$ctrl.ata.allowExternalRelations | prettyBoolean}}</td>
          <td>
            <select
              ng-disabled="!\$ctrl.command.enabled"
              ng-change="\$ctrl.reloadRelations()"
              ng-model="\$ctrl.command.allowExternalRelations"
              boolean-options>
            </select>
          </td>
        </tr>
        <tr ng-if="\$ctrl.command.enabled">
          <td></td>
          <td>Allow auto fund transfer from</td>
          <td>
            <ul class="readonly-list"
                ng-if="\$ctrl.ata.relationDefinitionsIds && \$ctrl.ata.relationDefinitionsIds.length > 0">
              <li ng-repeat="id in \$ctrl.ata.relationDefinitionsIds">
                {{\$ctrl.productTypeLabel(id)}}
              </li>
            </ul>
          </td>
          <td>
            <multiselect
              ng-disabled="!\$ctrl.command.enabled"
              ng-change="\$ctrl.reloadRelations()"
              items="\$ctrl.relationDefinitionsIds"
              ng-model="\$ctrl.command.relationDefinitionsIds">
            </multiselect>
          </td>
        </tr>
        <tr ng-if="\$ctrl.command.enabled">
          <td></td>
          <td>Trigger auto fund transfer after</td>
          <td>
            <ul class="readonly-list" ng-if="\$ctrl.ata.triggerCommands && \$ctrl.ata.triggerCommands.length > 0">
              <li ng-repeat="command in \$ctrl.ata.triggerCommands">
                {{command | startCase}}
              </li>
            </ul>
          </td>
          <td>
            <multiselect
              ng-disabled="!\$ctrl.command.enabled"
              items="\$ctrl.triggerCommands"
              ng-model="\$ctrl.command.triggerCommands">
            </multiselect>
          </td>
        </tr>
        <tr ng-if="\$ctrl.command.enabled">
          <td></td>
          <td>Allowed credit operations</td>
          <td>
            <ul class="readonly-list" ng-if="\$ctrl.ata.creditCommands && \$ctrl.ata.creditCommands.length > 0">
              <li ng-repeat="command in \$ctrl.ata.creditCommands">
                {{command | startCase}}
              </li>
            </ul>
          </td>
          <td>
            <multiselect
              ng-disabled="!\$ctrl.command.enabled"
              items="\$ctrl.creditCommands"
              ng-model="\$ctrl.command.creditCommands">
            </multiselect>
          </td>
        </tr>
        <tr ng-if="\$ctrl.command.enabled">
          <td></td>
          <td>{{ \$ctrl.ataLabels.replenishmentFlag }}</td>
          <td>{{ \$ctrl.ata.replenishEnabled | prettyBoolean }}</td>
          <td>
            <select
              required
              ng-change="\$ctrl.replenishUpdated()"
              ng-model="\$ctrl.command.replenishEnabled"
              boolean-options>
            </select>
          </td>
        </tr>
        <tr ng-if="\$ctrl.command.enabled && \$ctrl.command.replenishEnabled">
          <td></td>
          <td>{{ \$ctrl.ataLabels.replenishmentStrategy }}</td>
          <td>
            <select
              disabled
              ng-model="\$ctrl.ata.replenishStrategy"
              ng-options="entry.value as entry.label for entry in \$ctrl.ataReplenishStrategies">
            </select>
          </td>
          <td>
            <select
              required
              ng-disabled="!\$ctrl.command.enabled"
              ng-model="\$ctrl.command.replenishStrategy"
              ng-options="entry.value as entry.label for entry in \$ctrl.ataEnabledReplenishStrategies">
            </select>
          </td>
        </tr>
        <tr ng-if="\$ctrl.command.enabled && \$ctrl.command.replenishEnabled">
          <td></td>
          <td>{{ \$ctrl.ataLabels.replenishmentThreshold  }}</td>
          <td>{{ \$ctrl.ata.replenishThreshold | nxCurrency }}</td>
          <td>
            <cash
              ng-required="\$ctrl.command.replenishEnabled"
              ng-model="\$ctrl.command.replenishThreshold"
              ng-disabled="!\$ctrl.command.replenishEnabled"
              min="0"></cash>
          </td>
        </tr>

        </tbody>
      </table>

      <!-- ATA relations update -->

      <div id="ata-relations" ng-show="\$ctrl.command.enabled">

        <h2 class="section-header">Update account ATA relations</h2>

        <div class="alert" ng-show="!\$ctrl.multiselectRelations || \$ctrl.multiselectRelations.length === 0">
          There are no accounts that can be used as ATA relations.
        </div>
        <div class="alert alert--danger" ng-if="!\$ctrl.relationsValid">
          ATA relations are invalid: selected set contains deprecated accounts
        </div>

        <div class="clearfix"></div>

        <div class="ata-relation-boxes" ng-show="\$ctrl.multiselectRelations && \$ctrl.multiselectRelations.length > 0">

          <div class="ata-relation-box">
            <h2 class="section-header">Current ATA relations</h2>
            <ul class="ata-listing">
              <li ng-repeat="id in \$ctrl.account.ataRelationsIds" class="dragula-loans">
                {{\$ctrl.accountLabel(id)}}
              </li>
            </ul>
          </div>

          <div class="ata-relation-box form-section">
            <h2 class="section-header">Target ATA relations</h2>
            <multiselect
              ng-change="\$ctrl.validateRelations()"
              items="\$ctrl.multiselectRelations"
              ng-model="\$ctrl.command.ataRelationsIds">
            </multiselect>
          </div>

          <div class="ata-relation-box" ng-if="\$ctrl.command.ataRelationsIds.length > 0">
            <h2 class="section-header">Target ATA relations order</h2>
            <ul class="ata-listing" dragula='"relationsHierarchy"' dragula-model="\$ctrl.command.ataRelationsIds">
              <li ng-repeat="id in \$ctrl.command.ataRelationsIds" class="dragula-loans">
                {{\$ctrl.accountLabel(id)}}
              </li>
            </ul>
          </div>

        </div>

      </div>

      <div class="clearfix"></div>

      <div class="buttons">
        <button class="btn btn-warning" ng-click="\$ctrl.redirectBack()">Cancel</button>
        <button class="btn btn-primary" ng-click="\$ctrl.update()" ng-disabled="form.\$invalid || !\$ctrl.relationsValid">
          Update
        </button>
      </div>

    </form>
</section>
`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/customer/accounts/edit-ata/edit-account-ata.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;